export * from "./region-config.view";
